import { render, staticRenderFns } from "./SimulasiGadai.vue?vue&type=template&id=99787ace&scoped=true&"
import script from "./SimulasiGadai.vue?vue&type=script&lang=js&"
export * from "./SimulasiGadai.vue?vue&type=script&lang=js&"
import style0 from "./SimulasiGadai.vue?vue&type=style&index=0&id=99787ace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99787ace",
  null
  
)

export default component.exports